function InputText({ type, placeholder, onChange }) {
	return <input type={type} placeholder={placeholder} onChange={onChange} />;
}

export default InputText;
